import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { ValuesMarquee } from "@/components/landing/ValuesMarquee";
import { Struggles } from "@/components/landing/Struggles";
import { PreMarital } from "@/components/landing/PreMarital";
import { Story } from "@/components/landing/Story";
import { Testimonials } from "@/components/landing/Testimonials";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Booking } from "@/components/landing/Booking";
import { Donate } from "@/components/landing/Donate";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <ValuesMarquee />
      <Struggles />
      <Story />
      <Testimonials />
      <HowItWorks />
      <Booking />
      <PreMarital />
      <Donate />
      <ContactSection />
      <Footer />
    </main>
  );
}
